// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"Accordion_Accordion__e4f_c","title":"Accordion_title__hI8bq"};